import './settings.css';
import Authenticated from '../lib/authenticated';
import { useState } from 'react';
import { ToastContainer, toast } from 'react-toastify';

function updatePassword(userID, toast) {
    const password = document.getElementById("password").value;
    fetch(`/v1/api/staff/${userID}/secrets`, {
        method: 'PUT',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({
            type: 'password',
            secret: password,
        }),
    }).then(response => {
        if (response.ok) {
            toast("Password updated successfully.");
        } else {
            toast("Failed to update password. Please try again.");
        }
    });
}

function clearTokens(userID, toast) {
    fetch(`/v1/api/staff/${userID}/secrets`, {
        method: 'DELETE',
    }).then(response => {
        if (response.ok) {
            toast("Tokens cleared successfully.");
        } else {
            toast("Failed to clear tokens. Please try again.");
        }
    });
}

function generatePAT(userID, toast) {
    fetch(`/v1/api/staff/${userID}/secrets`, {
        method: 'PUT',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({
            type: 'personal_access_token',
        }),
    }).then(response => {
        if (response.ok) {
            response.json().then(data => {
                toast(`PAT Token generated: ${data.secret}`, { autoClose: false, closeOnClick: false });
            });
        } else {
            toast("Failed to generate PAT Token. Please try again.");
        }
    });
}

export default function Settings({ children }) {
    const [self, setSelf] = useState(null);

    return <Authenticated setter={setSelf}>
        <div className='settings'>
            <div className='panel'>
                <input type="password" id="password" placeholder="new password" />
                <button onClick={() => updatePassword(self.id, toast)}>Update Password</button>
                <button onClick={() => clearTokens(self.id, toast)}>Clear Tokens</button>
                <button onClick={() => generatePAT(self.id, toast)}>Generate PAT Token</button>
                <ToastContainer />
            </div>
            <main>
                {children}
            </main>
        </div>
    </Authenticated>;
}
